module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card mdl-cell mdl-cell--3-col mdl-cell--4-col-tablet mdl-cell--6-col-phone",
    attrs: {
      "data-i": _vm.i,
      "data-index": _vm.index,
      "data-value": _vm.data.id,
      "data-text": _vm.data.nombre,
      "data-father-id": _vm.data.padreId,
      "data-photo": _vm.data.imagen
    },
    on: {
      "click": _vm.clickEvent
    }
  }, [_c('div', {
    staticClass: "mdl-card__media mdl-color-text--grey-50",
    style: ('background-image:url(' + _vm.data.imagen + ')')
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text meta mdl-color-text--grey-600"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.data.nombre))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.data.hijosTotal + ' ' + _vm.data.hijosNombre))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2f55b4c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Roles/Auditor/Audit/Card.vue
// module id = 250
// module chunks = 0